import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../styles/lineup.css';

// Reusable accordion card for the deal-terms "More" section.
//
// Renders a bordered header bar with a leading `+` icon, a title label,
// optional count badge, and a chevron-down that rotates to chevron-up when
// open. Clicking anywhere on the header toggles the body. The body is only
// mounted while open.
//
// Supports controlled mode via { open, onToggle }; falls back to local state
// when only `defaultOpen` is provided.
const V3OfferAccordionCard = ({
  title,
  count,
  defaultOpen,
  open: controlledOpen,
  onToggle,
  children,
}) => {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(!!defaultOpen);
  const isControlled = controlledOpen !== undefined;
  const isOpen = isControlled ? !!controlledOpen : uncontrolledOpen;

  const toggle = () => {
    if (isControlled) {
      if (onToggle) onToggle(!isOpen);
    } else {
      setUncontrolledOpen((o) => !o);
    }
  };

  return (
    <div className={`deal-terms-card ${isOpen ? 'deal-terms-card--open' : ''}`}>
      <button
        type="button"
        className="deal-terms-card__header"
        onClick={toggle}
        aria-expanded={isOpen}
      >
        <span className="deal-terms-card__plus" aria-hidden="true">+</span>
        <span className="deal-terms-card__title">{title}</span>
        <span className="deal-terms-card__spacer" />
        {count !== null && count !== undefined && (
          <span className="deal-terms-card__count" data-testid="deal-terms-card-count">
            {count}
          </span>
        )}
        <i
          className={`deal-terms-card__chevron far ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}
          aria-hidden="true"
        />
      </button>
      {isOpen && (
        <div className="deal-terms-card__body">{children}</div>
      )}
    </div>
  );
};

V3OfferAccordionCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number,
  defaultOpen: PropTypes.bool,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.node,
};

V3OfferAccordionCard.defaultProps = {
  count: null,
  defaultOpen: false,
  open: undefined,
  onToggle: null,
  children: null,
};

export default V3OfferAccordionCard;
